module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-cascader', {
    staticClass: "inpText",
    attrs: {
      "collapse-tags": "",
      "clearable": "",
      "size": "medium",
      "placeholder": _vm.plaText,
      "options": _vm.selectArr,
      "props": {
        value: 'id',
        label: 'name',
        children: 'dataDictionarys',
        multiple: _vm.moreSelect,
        emitPath: false
      }
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.id),
      callback: function($$v) {
        _vm.id = $$v
      },
      expression: "id"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-5feacfe3"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/inCComps/dcTreeSelect.vue
// module id = 1505
// module chunks = 1